import { nanoid } from 'nanoid';
import { View } from 'pacto';

const SELECTOR_INPUT = '.password__input';

const CLASS_TOGGLE = 'password__toggle';
const CLASS_TOGGLE_LABEL = 'password__toggle__label';
const MODIFIER_IS_PRESSED = '--is-pressed';

const ATTR_ARIA_PRESSED = 'aria-pressed';
const ATTR_ARIA_CONTROLS = 'aria-controls';

export class Password extends View {
  constructor(options) {
    super(options);
    this.onClick = this.onClick.bind(this);
  }

  render() {
    const { el } = this;
    const input = el.querySelector(SELECTOR_INPUT);
    const toggle = document.createElement('button');

    input.id = input.id || `input-${nanoid()}`;
    toggle.classList.add(CLASS_TOGGLE);
    toggle.type = 'button';
    toggle.setAttribute(ATTR_ARIA_PRESSED, 'false');
    toggle.setAttribute(ATTR_ARIA_CONTROLS, input.id);
    toggle.innerHTML = `<span class="${CLASS_TOGGLE_LABEL}">Passwort anzeigen</span>`;
    el.appendChild(toggle);

    toggle.addEventListener('click', this.onClick);

    this.input = input;
    this.toggle = toggle;
  }

  destroy() {
    this.toggle.remove();
    this.toggle = null;
    this.input = null;
  }

  onClick() {
    const { input, toggle } = this;
    const { classList } = toggle;

    if (input.type === 'password') {
      input.setAttribute('type', 'text');
      toggle.setAttribute(ATTR_ARIA_PRESSED, 'true');
      classList.add(`${CLASS_TOGGLE}${MODIFIER_IS_PRESSED}`);
    } else {
      input.setAttribute('type', 'password');
      toggle.setAttribute(ATTR_ARIA_PRESSED, 'false');
      classList.remove(`${CLASS_TOGGLE}${MODIFIER_IS_PRESSED}`);
    }
  }
}
